/**
 * Public-site link targets in one place.
 */

/**
 * Existing in-app welcome video. Do not advertise a duration or product tour
 * that this video does not provide. Keep the target and CTA tracking stable.
 */
export const TOUR_VIDEO_URL = "https://www.loom.com/share/e2a181e414034aebb2c792b2c642ab53";

export const SIGNUP_PATH = "/signup";
export const LOGIN_PATH = "/app/login";
export const SYRE_PATH = "/syre";

/** Anchor of the A13 terms section. */
export const TERMS_PRICING_ANCHOR = "pricing-trials-refunds-lifetime";
export const TERMS_PRICING_HREF = `/terms#${TERMS_PRICING_ANCHOR}`;

export const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

/**
 * `/signup` plus any extra params, carrying the current page's UTM params
 * through so a campaign link to any public page still reaches signup tagged.
 */
export function signupHref(extra: Record<string, string> = {}, currentSearch?: string): string {
  const params = new URLSearchParams();
  const search =
    currentSearch ?? (typeof window !== "undefined" ? window.location.search : "");
  const current = new URLSearchParams(search);
  for (const key of UTM_KEYS) {
    const value = current.get(key);
    if (value) params.set(key, value);
  }
  for (const [key, value] of Object.entries(extra)) params.set(key, value);
  const qs = params.toString();
  return qs ? `${SIGNUP_PATH}?${qs}` : SIGNUP_PATH;
}
